import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * QaqcFormEdit - Page wrapper for editing filled QAQC forms
 * Used for navigation in routes/index.tsx
 */
const QaqcFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default QaqcFormEdit;
